import { Controller } from '@hotwired/stimulus';

// on the toggle button, the content will show.
// focus loss on the input will hide the input and show the toggle button again.
export default class extends Controller {
  static targets = ['input', 'label', 'show', 'toggler']

  connect() {
    this.togglerTarget.addEventListener('click', this.enable_input.bind(this))
    this.inputTarget.addEventListener('blur', this.disable_input.bind(this))
    this.inputTarget.addEventListener('change', this.disable_input.bind(this))
    this.inputTarget.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        this.disable_input()
      }
    })
  }

  enable_input () {
    this.inputTarget.classList.remove('d-none')
    this.inputTarget.focus()
    this.togglerTarget.classList.add('d-none')
    this.showTarget.classList.add('d-none')
    if (this.hasLabelTarget) {
      this.labelTarget.classList.add('d-none')
    }
  }

  disable_input () {
    this.showTarget.textContent = this.inputTarget.value
    this.inputTarget.classList.add('d-none')
    this.togglerTarget.classList.remove('d-none')
    this.showTarget.classList.remove('d-none')
    if (this.hasLabelTarget) {
      this.labelTarget.classList.remove('d-none')
    }
  }
}
